import React from 'react';

export const Header = () => {

  const navStyle = {
    backgroundColor: '#0b0251ff',
    height: '60px',
    padding: '0 20px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.35)'
  };

  const brandStyle = {
    color: 'beige',
    fontSize: '22px',
    fontWeight: 'bold',
    textDecoration: 'none',
  };

  const linkStyle = {
    color: 'beige',
    fontSize: '16px',
    fontWeight: '500'
  };

  const inputStyle = {
    borderRadius: '6px',
    border: 'none',
    outline: 'none'
  };

  const buttonStyle = {
    backgroundColor: '#198754', // bootstrap green
    border: 'none',
    borderRadius: '6px',
    color: 'white',
    fontWeight: '500'
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark" style={navStyle}>
      <div className="container-fluid">
        <div className="navbar-brand" href="#" style={brandStyle}>
          Student Notes
        </div>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
        >
          <span
            className="navbar-toggler-icon"
            style={{ filter: 'invert(1)' }}
          ></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <div className="nav-link active" href="#" style={linkStyle}>Home</div>
            </li>
            <li className="nav-item">
              <div className="nav-link" href="#" style={linkStyle}>About</div>
            </li>
            <li className="nav-item">
              <div className="nav-link" href="#" style={linkStyle}>Help</div>
            </li>
          </ul>
          <form className="d-flex" role="search">
            <input
              className="form-control me-2"
              type="search"
              placeholder="Search notes..."
              style={inputStyle}
            />
            <button
              className="btn"
              type="submit"
              style={buttonStyle}
            >
              Search
            </button>
          </form>
        </div>
      </div>
    </nav>
  );
};
